import { render, staticRenderFns } from "./classfx.vue?vue&type=template&id=5686c701&scoped=true&"
import script from "./classfx.vue?vue&type=script&lang=js&"
export * from "./classfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5686c701",
  null
  
)

export default component.exports